document.addEventListener("DOMContentLoaded", function () {
  console.log("Custom Animations JS Loaded");

  var cards = gsap.utils.toArray("#custom-animations-section .custom-animations-card"),
    dragDistancePerRotation = 3000,
    radius = 520,
    proxy = document.createElement("div"),
    progressWrap = gsap.utils.wrap(0, 1),
    spin = gsap.fromTo(
      cards,
      { rotationY: (i) => i * (360 / cards.length) },
      {
        rotationY: "-=360",
        duration: 20,
        ease: "none",
        repeat: -1,
        transformOrigin: "50% 50% " + -radius + "px",
      }
    ),
    startProgress;

  // Draggable setup
  Draggable.create(proxy, {
    trigger: "#custom-animations-section .custom-animations-wrapper",
    type: "x",
    inertia: true,
    onPress() {
      gsap.killTweensOf(spin);
      spin.timeScale(0);
      startProgress = spin.progress();
    },
    onDrag: function () {
      let p = startProgress + (this.startX - this.x) / dragDistancePerRotation;
      spin.progress(progressWrap(p));
    },
    onRelease: function () {
      gsap.to(spin, { timeScale: 1, duration: 0.3 });
    },
    onThrowComplete() {
      gsap.to(spin, { timeScale: 1, duration: 0.3 });
    },
  });

  // Function to pause and resume spin
  function pauseSpin() {
    gsap.to(spin, { timeScale: 0, duration: 0.3 });
  }

  function resumeSpin() {
    gsap.to(spin, { timeScale: 1, duration: 0.3 });
  }

  // Event listeners for desktop and mobile
  cards.forEach(function (card) {
    // Pause spin on mouse enter / touch start
    card.addEventListener("mouseenter", pauseSpin);
    card.addEventListener("touchstart", function (e) {
      pauseSpin();
      e.stopPropagation(); // Prevent interference with drag
    });

    // Resume spin on mouse leave / touch end or touch cancel
    card.addEventListener("mouseleave", resumeSpin);
    card.addEventListener("touchend", resumeSpin);
    card.addEventListener("touchcancel", resumeSpin);
  });
});